import React from 'react';

const NoMatch = () => {
  return (
    <div className="no-match">
      <p>Oops, we couldn't find that page.</p>
    </div>
  );
};

export default NoMatch;
